<template>
  <div class="flex items-center mb-12 lg:mb-11 text-xl font-bold text-text leading-tight">
    {{ $t('title') }}
  </div>
</template>

<script>
export default {
  name: "MyInvestmentPortfoliosTitle",
  i18n: {
    messages: {
      ru: {
        title: 'Инвестиции'
      },
      en: {
        title: 'Investments'
      }
    }
  }
}
</script>

<style scoped>

</style>